import { InjectionToken } from '@angular/core';

export interface IApiConfigService {
  loginUrl(): string;
  accountApiUrl(): string;
  logoutApiUrl(): string;
  refreshTokenUrl(): string;
  forgotPasswordUrl(): string;
  changePasswordUrl(): string;
}

export const API_CONFIG_SERVICE = new InjectionToken<any>('PacificwiseAngularApiConfigService');
